module.exports = __webpack_public_path__ + "media/burial-document_1200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/burial-document_1200.jpg
// module id = 12
// module chunks = 0